import React from "react";
import { ICertificate } from "../../interface/ICertificate";
import { useHelper } from "../../features/functions/helper.tsx";
import ToggleIcon from "../../img/inline/ToggleIcon.tsx";
import FakeInput from "../Form/FakeInput.tsx";
import { NavLink } from "react-router";

const SingleCertificateItemRepeater = ({
    toggleAccount,
    index, 
    toggledStates,
    certificateTypes,
    certificate,
    clientCertificates,
    clientAccounts
}: {
    toggleAccount: Function,
    index: number,
    toggledStates: Array<number>,
    certificateTypes: Array<string>,
    certificate: ICertificate,
    clientCertificates: any,
    clientAccounts: any
}) => {
    const { formatDateFromTimestamp, formatCurrency, isBankingCertificate } = useHelper();

    let type = certificate.type.replaceAll(' ', '').toLowerCase();
    let imgSrc = '';
    imgSrc = type + '.jpg';
    
    let isEmeritus = type === 'fpsbemeritus';
    
    return (        
        <div className={`certifcate-item single-repeater-item ${type}`}>
            <div className="certificate-details">
                <h5 className="repeater-toggle-headline with-image" onClick={() => toggleAccount(index)}><div className="name-with-img"><img src={require(`../../img/files/certificates/${imgSrc}`)} key={'img_'+index} alt={`Zertifikat cfep`}/></div>{ isEmeritus ? '' : <ToggleIcon toggled={toggledStates[index]} /> }</h5>
                {(isEmeritus || toggledStates[index]) && (
                    <div className="content fake-form">
                        <>
                            {   certificateTypes.length === 1 &&
                                certificate.next_recertification && 
                                certificate.next_recertification !== '0' ? ( //Just this one Cert
                                <FakeInput
                                    value={formatDateFromTimestamp(certificate.next_recertification)}
                                    label='Nächste Re-Zertifizierung'
                                />
                            ) : '' }                                                            
                            {   certificateTypes.length >= 2 && 
                                certificateTypes.length < 4 && 
                                (
                                    (certificateTypes.includes('CFP') && certificateTypes.includes('EFA')) ||
                                    (certificateTypes.includes('CFP') && certificateTypes.includes('CFEP')) ||
                                    (certificateTypes.includes('CFP') && certificateTypes.includes('CGA')) ||
                                    (certificateTypes.includes('CFP') && certificateTypes.includes('CFEP') && certificateTypes.includes('CGA'))
                                ) &&
                                clientCertificates['CFP'].next_recertification !== '0' ? (
                                <FakeInput
                                    value={formatDateFromTimestamp(clientCertificates['CFP'].next_recertification)}
                                    label='Nächste Re-Zertifizierung'
                                />
                            ) : '' }
                            {   certificateTypes.length === 2 && 
                                certificateTypes.includes('CFEP') && 
                                certificateTypes.includes('EFA') &&
                                clientCertificates['CFEP'].next_recertification !== '0' &&
                                !isEmeritus ? (
                                <FakeInput
                                    value={formatDateFromTimestamp(clientCertificates['CFEP'].next_recertification)}
                                    label='Nächste Re-Zertifizierung'
                                />
                            ) : '' }
                            {   certificateTypes.length >= 4 && 
                                certificateTypes.includes('CFP') && 
                                clientCertificates['CFP'].next_recertification !== '0' &&
                                !isEmeritus ? (
                                <FakeInput
                                    value={formatDateFromTimestamp(clientCertificates['CFP'].next_recertification)}
                                    label='Nächste Re-Zertifizierung'
                                />
                            ) : '' }
                        </>
                        { certificate.date_first_certification && certificate.date_first_certification !== '0' ? (
                            <FakeInput
                                value={formatDateFromTimestamp(certificate.date_first_certification)}
                                label='Datum Erstzertifizierung'
                            />
                        ) : ''}
                        { certificate.start && certificate.start !== 0 ? (
                            <FakeInput
                                value={formatDateFromTimestamp(certificate.start)}
                                label='Zertifiziert seit'
                            />
                        ) : ''}
                        { certificate.name && (
                            <FakeInput
                                value={certificate.name}
                                label='Zertifikatsnummer'
                            />
                        )}
                        { certificate.old_licence_number && (
                            <FakeInput
                                value={certificate.old_licence_number}
                                label='Zertifikatsnummer (alt)'
                            />
                        )}
                        { certificate.type === 'EFA' && (
                            <>
                                { certificateTypes.includes('CFP') && (
                                    <FakeInput
                                        value='Rabatt 100%, Jahresbeitrag ist über CFP-Zertifikat abgedeckt'
                                        label='Jahresbeitrag'
                                    />
                                ) }
                                { !certificateTypes.includes('CFP') && certificate.eurnetto2 !== null ? (
                                    <FakeInput
                                        value={formatCurrency(certificate.eurnetto2)}
                                        label='Jahresbeitrag'
                                    />
                                ) : '' }
                            </>
                        ) }
                        { certificate.type === 'CGA' && (
                            <>
                                { certificateTypes.includes('CFEP') && (
                                    <FakeInput
                                        value='Jahresbeitrag: Rabatt 100%, Jahresbeitrag ist über CFEP-Zertifikat abgedeckt'
                                        label='Jahresbeitrag'
                                    />
                                ) }
                                { !certificateTypes.includes('CFEP') && certificate.eurnetto2 !== null ? (
                                    <FakeInput
                                        value={formatCurrency(certificate.eurnetto2)}
                                        label='Jahresbeitrag'
                                    />
                                ) : '' }
                            </>
                        ) }
                        { (isBankingCertificate(certificate.type) && !isEmeritus) ? (
                            <>
                                { !(certificate.type === 'CGA' && certificateTypes.includes('CFEP')) && !(certificate.type === 'EFA' && certificateTypes.includes('CFP')) ? (
                                    certificate.client_account_id && certificate.client_account_id !== 0 && Object.keys(clientAccounts).length > 0 ? (
                                        <div className='form-group'>
                                            <span className="label">Rechnungskonto</span>
                                            <NavLink className={'button button-primary'} to={`/profile/bankconnection/${certificate.client_account_id}`} end>{clientAccounts[certificate.client_account_id]}</NavLink>
                                        </div>
                                    ) : (
                                        <div className='form-group'>
                                            <span className="label">Rechnungskonto</span>
                                            <div>Bitte geben Sie ein <NavLink to={`/profile/bankconnection`} end>Rechnungskonto</NavLink> für dieses Zertifikat an</div>
                                        </div>
                                    )
                                ) : ''}
                                { (certificate.type !== 'EFA' && certificate.type !== 'CGA' && certificate.eurnetto2 !== null) ? (
                                    <FakeInput
                                        value={formatCurrency(certificate.eurnetto2)}
                                        label='Jahresbeitrag'
                                    />
                                ) : ''}
                            </>
                        ) : '' }
                    </div>
                )}
                { !isEmeritus ? ( ''
                ) : '' }
            </div>
        </div>
    )
}

export default SingleCertificateItemRepeater;